
import * as CryptoJS from "crypto-js";
import * as SecureStorage from "secure-web-storage";

export const SECRET_KEY =
  "@-[3-)p7AZ[IFMfOUR-.`|%tAH6SaQrQ.y_M|ksj$|7:?~B!&`bGO1X6eq_(1FmJ";

export const secureStorage = new SecureStorage(localStorage, {
  hash: function hash(key) {
    key = CryptoJS.SHA256(key, SECRET_KEY);

    return key.toString();
  },
  encrypt: function encrypt(data) {
    data = CryptoJS.AES.encrypt(data, SECRET_KEY);

    data = data.toString();

    return data;
  },
  decrypt: function decrypt(data) {
    data = CryptoJS.AES.decrypt(data, SECRET_KEY);

    data = data.toString(CryptoJS.enc.Utf8);

    return data;
  },
});

export function getSecureItem(key: any) {
  const hashKey = secureStorage.hash(key);
  const data = localStorage.getItem(hashKey);
  let decryptedData: any = null;
  data && (decryptedData = secureStorage.decrypt(data));
  return decryptedData;
}

export function setSecureItem(key: any, val: any) {
  const hashKey = secureStorage.hash(key);
  const encryptedData = secureStorage.encrypt(val);
  localStorage.setItem(hashKey, encryptedData);
}